/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
export var ActionType;
(function (ActionType) {
    ActionType["RESET"] = "RESET";
    ActionType["CHANGE_LANG"] = "CHANGE_LANG";
    ActionType["REFRESH_LANG_LIST"] = "REFRESH_LANG_LIST";
})(ActionType || (ActionType = {}));
